import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepaidRedeemedSuccessDisplay } from '../../../../models/prepaid-purchase-status.util';

@Component({
  selector: 'app-prepaid-redeemed-success-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './prepaid-redeemed-success-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./prepaid-redeemed-success-modal.component.scss'],
})
export class PrepaidRedeemedSuccessModalComponent {
  @Input() isVisible = false;
  @Input() data: PrepaidRedeemedSuccessDisplay = {
    packageLabel: '',
    washName: '',
    washType: '',
    purchaseDate: '',
    validTill: '',
  };

  /**
   * CWS-1882: a redemption the backend treated as a repeat of a visit recorded moments ago
   * drew no extra wash, so the heading and note must say that instead of claiming a fresh
   * redemption. Both default to the original success copy.
   */
  @Input() title = 'Prepaid Redeemed Successfully!';
  @Input() note = '';

  @Output() close = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onGotIt(): void {
    this.primaryAction.emit();
    this.close.emit();
  }

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
